import { useState } from 'react';
import { fetchWithAuth } from '../Utils/fetchWithAuth'; 

export default function usePost() {
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading]           = useState(false);
  const [error, setError]               = useState(null);

  const postData = async (url, dataToPost, method = 'POST') => {
    setLoading(true);
    setError(null);
    setResponseData(null);

    try {
      // Prepara le opzioni di fetch
      const fetchOptions = {
        method: method,
      };

      // Se dataToPost è FormData, non impostare Content-Type (il browser lo fa automaticamente)
      // Altrimenti usa JSON
      if (dataToPost instanceof FormData) {
        fetchOptions.body = dataToPost;
      } else {
        fetchOptions.headers = {
          'Content-Type': 'application/json',
        };
        fetchOptions.body = JSON.stringify(dataToPost);
      }

      const response = await fetchWithAuth(url, fetchOptions);

      const json = await response.json();

      if (!response.ok) {
        // Estrai il messaggio di errore dal backend se disponibile
        let errorMessage = json.error || json.message || `Errore nella richiesta: ${response.status}`;
        
        // Se ci sono dettagli di validazione, costruisci un messaggio più dettagliato
        if (json.details) {
          const fieldErrors = Object.entries(json.details)
            .map(([field, message]) => `• ${field}: ${message}`)
            .join('\n');
          errorMessage = `${errorMessage}:\n${fieldErrors}`;
        }
        
        const error = new Error(errorMessage);
        error.details = json.details; // Aggiungi i dettagli all'errore per uso futuro
        throw error;
      }

      setResponseData(json);
      return json;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { responseData, loading, error, postData };
}
